import { z } from 'zod';
export const organizationGroupApiRoutes = {
    read: {
        method: 'GET',
        path: '/organization/:organizationId/group/:groupId',
        output: {},
    },
    list: {
        method: 'GET',
        path: '/organization/:organizationId/group',
        output: {},
    },
    create: {
        method: 'POST',
        path: '/organization/:organizationId/group',
        input: z.object({
            name: z.string(),
            icon: z.string().optional(),
            membershipIds: z.array(z.string()).optional(),
        }),
        output: {},
    },
    update: {
        method: 'POST',
        path: '/organization/:organizationId/group/:groupId',
        input: z.object({
            name: z.string().optional(),
            icon: z.string().optional(),
        }),
        output: {},
    },
    delete: {
        method: 'DELETE',
        path: '/organization/:organizationId/group/:groupId',
        output: {},
    },
    inviteMember: {
        method: 'POST',
        path: '/organization/:organizationId/group/:groupId/invite',
        input: z.object({
            membershipIds: z.array(z.string()),
        }),
        output: {},
    },
    dismissMember: {
        method: 'DELETE',
        path: '/organization/:organizationId/group/:groupId/dismiss/:organizationGroupMembershipId',
        output: {},
    },
    leave: {
        method: 'DELETE',
        path: '/organization/:organizationId/group/:groupId/leave',
        output: {},
    },
};
//# sourceMappingURL=organization-group-api-routes.js.map